import React, { Component } from 'react'
import { Router, Route, Switch } from "react-router-dom";
import { Provider } from 'react-redux';
import store from 'store/store';
import history from 'utils/History/history';

import indexRoutes from "./routes/index.jsx";

import Auth from "./utils/Auth/Auth";

import { AUTHENTICATED_HOME, NOT_AUTHENTICATED_HOME } from 'routes/routesConstants';
import Pages from "layouts/Pages/Pages.jsx";
import Dashboard from "layouts/Dashboard/Dashboard.jsx";

const handleAccesibility = (needAuth, props) => {
    const auth = new Auth();
    console.log("needAuth: " + needAuth);
    console.log("isAuthenticated: " + auth.isAuthenticated());

    if (props.location.pathname === "/pages/reset-password") {
        auth.logoutWithoutRedirection();
        return <Pages {...props} />;
    }

    if (needAuth == true && !auth.isAuthenticated()) {
        console.log("NeedAuth and is Not Authenticated");
        history.push(NOT_AUTHENTICATED_HOME);
        return <Pages {...props} />;
    } else {
        if (needAuth == false && auth.isAuthenticated()) {
            console.log("Not NeedAuth and is Authenticated", props);
            history.push(AUTHENTICATED_HOME);
            return <Dashboard {...props} />;
        }
    }
    return null;
}

const AuthRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => {
        console.log("rest: ", rest);
        let resComp = handleAccesibility(rest.data.needAuth, props);
        if (resComp != null) {
            console.log("resComp not null: ", resComp);
            return resComp;
        }
        return <Component {...props} />;
    }} />
)

export default class App extends Component {

    render() {
        return (
            <div>
                <Provider store={store}>
                    <Router history={history}>
                        <Switch>
                            {indexRoutes.map((prop, key) => {
                                return <AuthRoute
                                    path={prop.path}
                                    data={prop}
                                    component={prop.component}
                                    key={key} />;
                            })}
                        </Switch>
                    </Router>
                </Provider>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/App.jsx